import React, { useRef } from "react";
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import { Box, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';

export default function ProgressMobileStepper() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [accesoMicrofonoVerificado, setAccesoMicrofonoVerificado] = React.useState(null);
  const [funcionamientoMicrofono, setFuncionamientoMicrofono] = React.useState(null);

  const [funcionamientoSonido, setFuncionamientoSonido] = React.useState(null);

  const [accesoCamaraVerificado, setAccesoCamaraVerificado] = React.useState(null);
  const [funcionamientoCamara, setFuncionamientoCamara] = React.useState(null);
  const [resolucionesCamara, setResolucionesCamara] = React.useState(null);
  const [resolucionQVGACamara, setResolucionQVGACamara] = React.useState(null);
  const [resolucionVGACamara, setResolucionVGACamara] = React.useState(null);
  const [resolucionHDCamara, setResolucionHDCamara] = React.useState(null);
  const [resolucionFullHDCamara, setResolucionFullHDCamara] = React.useState(null);
  const [resolucion2kCamara, setResolucion2kCamara] = React.useState(null);
  const [resolucion4kCamara, setResolucion4kCamara] = React.useState(null);

  const [senializacion, setSenializacion] = React.useState(null);
  const [retransmision, setRetransmision] = React.useState(null);

  const handleNext = () => {
    console.log("handleNext");
    console.log(activeStep)
    if (activeStep === 1) {
      if (step2Ref.current) {
        setAccesoMicrofonoVerificado(step2Ref.current.getAccesoMicrofonoVerificado());
        setFuncionamientoMicrofono(step2Ref.current.getFuncionamientoMicrofono());
      }
    } else if (activeStep === 2) {
      if (step3Ref.current) {
        step3Ref.current.getFuncionamientoSonido();
        setFuncionamientoSonido(step3Ref.current.getFuncionamientoSonido());
      }
    } else if (activeStep === 3) {
      if (step4Ref.current) {
        setAccesoCamaraVerificado(step4Ref.current.getAccesoCamaraVerificado());
        setFuncionamientoCamara(step4Ref.current.getFuncionamientoCamara());
        setResolucionesCamara(step4Ref.current.getResolucionesCamara());
        setResolucionQVGACamara(step4Ref.current.getResolucionQVGACamara());
        setResolucionVGACamara(step4Ref.current.getResolucionVGACamara());
        setResolucionHDCamara(step4Ref.current.getResolucionHDCamara());
        setResolucionFullHDCamara(step4Ref.current.getResolucionFullHDCamara());
        setResolucion2kCamara(step4Ref.current.getResolucionFull2kCamara());
        setResolucion4kCamara(step4Ref.current.getResolucionFull4kCamara());
      }
    } else if (activeStep === 4) {
      if (step5Ref.current) {
        setSenializacion(step5Ref.current.getAccesoServidorSenializacion());
        setRetransmision(step5Ref.current.getAccesoServidorRetransmision());
      }
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const restart = () => {
    setAccesoMicrofonoVerificado(false);
    setFuncionamientoMicrofono(false);
    setFuncionamientoSonido(false);
    setAccesoCamaraVerificado(false);
    setFuncionamientoCamara(false);
    setResolucionesCamara("");
    setResolucionQVGACamara(false);
    setResolucionVGACamara(false);
    setResolucionHDCamara(false);
    setResolucionFullHDCamara(false);
    setResolucion2kCamara(false);
    setResolucion4kCamara(false);
    setSenializacion(false);
    setRetransmision(false);
    setActiveStep(0);
  };

  const step2Ref = useRef();
  const step3Ref = useRef();
  const step4Ref = useRef();
  const step5Ref = useRef();
  const steps = [
    <Step1 />,
    <Step2 ref={ step2Ref } />,
    <Step3 ref={ step3Ref } handleNext={handleNext} />,
    <Step4 ref={ step4Ref } handleNext={handleNext} />,
    <Step5 ref={ step5Ref }/>,
    <Step6 accesoMicrofono={accesoMicrofonoVerificado} funcionamientoMicrofono={funcionamientoMicrofono} 
      accesoCamara={accesoCamaraVerificado} funcionamientoCamara={funcionamientoCamara} 
      resolucionesCamara={resolucionesCamara} resolucionQVGACamara={resolucionQVGACamara}
      resolucionVGACamara={resolucionVGACamara} resolucionHDCamara={resolucionHDCamara}
      resolucionFullHDCamara={resolucionFullHDCamara} resolucion2kCamara={resolucion2kCamara}
      resolucion4kCamara={resolucion4kCamara} funcionamientoSonido={funcionamientoSonido}
      senializacion={senializacion} retransmision={retransmision} restart={restart}
      />];

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box sx={{ maxWidth: 400, flexGrow: 1, margin: 'auto', textAlign: 'center' }}>
      {steps[activeStep]}
      <MobileStepper
        variant="progress"
        steps={6}
        position="static"
        activeStep={activeStep}
        sx={{ maxWidth: 400, flexGrow: 1 }}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === 5 }>
            Siguiente
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Atrás
          </Button>
        }
      />
    </Box>
  );
}
